import axiosInstance from "./axios";
import {
  CreateReportingCyclePayload,
  ReportingCycle,
  UpdateReportingCyclePayload,
} from "./models/reportingCycle.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchReportingCycles = async (
  bearerToken: string,
  companyId
): Promise<ReportingCycle[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Report/reports/${companyId}/reportcycles`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch reporting cycles:", error);
    throw error;
  }
};

export const adminFetchReportingCycles = async (
  bearerToken: string,
  companyId: string
): Promise<ReportingCycle[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Admin/reportcycles?companyId=${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch reporting cycles:", error);
    throw error;
  }
};

export const adminUpdateReportingCycle = async (
  bearerToken: string,
  payload: UpdateReportingCyclePayload
): Promise<ReportingCycle> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Admin/reportcycles`,
      {
        id: payload.id,
        companyId: payload.companyId,
        year: payload.year,
        cycle: payload.cycle,
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update reporting cycle:", error);
    throw error;
  }
};

export const createReportingCycle = async (
  bearerToken: string,
  payload: CreateReportingCyclePayload
): Promise<ReportingCycle> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Report/reports/${payload.companyId}/reportcycles`,
      {
        companyId: payload.companyId,
        year: payload.year,
        cycle: payload.cycle,
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create reporting cycle:", error);
    throw error;
  }
};

export const updateReportingCycle = async (
  bearerToken: string,
  payload: UpdateReportingCyclePayload
): Promise<ReportingCycle> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Report/reports/${payload.companyId}/reportcycles/${payload.id}`,
      {
        year: payload.year,
        cycle: payload.cycle,
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update reporting cycle:", error);
    throw error;
  }
};
